import React, { useState } from "react";
import { MessageSquare, MessagesSquare } from "lucide-react";
import Comments from "@/components/Comments";
import TitleChat from "@/components/TitleChat";

const TABS = [
  { id: "comments", label: "Comments", icon: MessageSquare },
  { id: "chat",     label: "Live Chat", icon: MessagesSquare },
];

export default function CommentsChatTabs({ tmdbId, mediaType }) {
  const [tab, setTab] = useState("comments");
  return (
    <div className="mt-6">
      <div
        role="tablist"
        data-testid="title-comments-chat-tabs"
        className="flex items-center gap-1 border-b border-[var(--tt-border)] mb-4 px-1"
      >
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.id;
          return (
            <button
              key={t.id}
              role="tab"
              aria-selected={active}
              onClick={() => setTab(t.id)}
              data-testid={`title-tab-${t.id}`}
              className={`relative inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider px-3 py-2.5 transition-colors ${active
                ? "text-[var(--tt-primary)]"
                : "text-[var(--tt-text-muted)] hover:text-white"}`}
            >
              <Icon className="w-3.5 h-3.5" />
              {t.label}
              {active && (
                <span className="absolute inset-x-2 -bottom-px h-[2px] bg-[var(--tt-primary)] rounded-full" />
              )}
            </button>
          );
        })}
      </div>

      {tab === "comments" ? (
        <Comments tmdbId={tmdbId} mediaType={mediaType} />
      ) : (
        <TitleChat tmdbId={tmdbId} mediaType={mediaType} />
      )}
    </div>
  );
}
